import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import payOnline from "../../assets/images/png/payOnline.png";
import secureTransaction from "../../assets/images/png/secureTransaction.png";
import deliverTruck from "../../assets/images/png/deliverTruck.png";
import FarmerCityVerified from "../../assets/images/png/FarmerCityVerified.png";

const IconSection = () => {
  const [data, setData] = useState([
    {
      img: deliverTruck,
      head: `Hassle-free Delivery`,
    },
    {
      img: payOnline,
      head: `Hassle-free Finance`,
    },
    {
      img: secureTransaction,
      head: `Secure Transaction`,
    },
    {
      img: FarmerCityVerified,
      head: `Farmer's City Verified`,
    },
  ]);
  return (
    <div className="pt-1">
      <Container className="px-0">
        <Row>
          {data.map((value, index) => (
            <Col key={index} xs={6} lg={3} className="text-center mt-4">
              <div className="icons-cards h-100 py-4 px-3 rounded-2">
                <img
                  style={{ width: "80px", height: "60px" }}
                  className="object-fit-contain"
                  src={value.img}
                  alt=""
                />
                <p className="ff_heebo fs_xsm fw-semibold mt-2 mb-0">
                  {value.head}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default IconSection;
